import { resolvers as currencyClientResolvers } from './schemas/currencyClientSchema'
import { resolvers as priceClientResolvers } from './schemas/priceClientSchema'

export const resolvers = [currencyClientResolvers, priceClientResolvers]
